import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
import {
  IconButton,
  TextField,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import set from "lodash/fp/set";
import { Fragment } from "react";

type Props<valueProp extends string> = {
  placeholder?: string;
  value: {
    [key in valueProp]: string;
  }[],
  valueProp: valueProp;
  onChange: (newValue: {
    [key in valueProp]: string;
  }[]) => void;
  disabled?: boolean;
}

function ValueList<valueProp extends string>({
  placeholder,
  value,
  valueProp,
  onChange,
  disabled,
}: Props<valueProp>) {
  const rows = value.length > 0 ? value : [{ [valueProp]: "" }] as typeof value

  return <Grid container sx={{ mt: 2 }}>
    {rows.map((item, index) => <Fragment key={index}>
      <Grid size={10}>
        <TextField
          fullWidth
          size="small"
          value={item[valueProp]}
          placeholder={placeholder}
          onChange={(e) => onChange(set(`${index}.${valueProp}`, e.target.value, rows))}
          disabled={disabled}
        />
      </Grid>
      <Grid size={2}>
       <IconButton
          onClick={() => onChange(value.filter(i => i !== item))}
          disabled={disabled || (index === 0 && !item[valueProp])}
        >
          <RemoveCircleOutlineIcon />
        </IconButton>
      </Grid>
    </Fragment>)}

    <Grid size={10}></Grid>
    <Grid size={2}>
      <IconButton
        onClick={() => onChange([...rows, { [valueProp]: "" } as any])}
        disabled={disabled}
      >
        <AddCircleOutlineIcon />
      </IconButton>
    </Grid>
  </Grid>
}

export default ValueList;
